<template>
  <DetailsPane
    :title="title || event.name"
    :hide-title="hideTitle"
    :tabs="tabs"
    :current-tab="currentTab"
    :hide-close="hideClose"
    :height="height"
    :auto-height="autoHeight"
    @show-tab="showTab"
    @close="$emit('close')"
  >
    <DetailsTab slot="tab-details" :event="event" :hide-trainer="true" />
    <RosterTab slot="tab-roster" :event="event" :section="section" />
    <TrainerTab slot="tab-trainer" :event="event" />
    <DownloadsTab slot="tab-downloads" :event="event" />
    <ShippingTab slot="tab-shipping" :event="event" />
  </DetailsPane>
</template>

<script>
import DetailsPane from "components/listings/DetailsPane";
import DetailsPaneMixin from "mixins/DetailsPane";
import DetailsTab from "./DetailsPaneTabs/Details";
import TrainerTab from "./DetailsPaneTabs/Trainer";
import DownloadsTab from "./DetailsPaneTabs/Downloads";
import ShippingTab from "./DetailsPaneTabs/Shipping";
import RosterTab from "./DetailsPaneTabs/Roster";

export default {
  mixins: [DetailsPaneMixin],
  components: {
    DetailsPane,
    DetailsTab,
    TrainerTab,
    DownloadsTab,
    ShippingTab,
    RosterTab,
  },
  props: {
    event: { type: Object, required: true },
    tab: { type: String, default: "details" },
    section: { type: String, default: "registration" },
  },
  data() {
    return {
      currentTab: "details",
    };
  },
  computed: {
    tabs() {
      let tabs = [];
      tabs.push({
        key: "details",
        label: "Details",
        icon: "details",
        ga_category: "Event",
        ga_label: this.gaLabel,
        ga_value: this.event.id,
      });
      tabs.push({
        key: "roster",
        label: "Roster",
        icon: "classroom",
        ga_category: "Event",
        ga_label: this.gaLabel,
        ga_value: this.event.id,
      });
      tabs.push({
        key: "trainer",
        label: "Trainer",
        icon: "trainer",
        ga_category: "Event",
        ga_label: this.gaLabel,
        ga_value: this.event.id,
      });
      if (!!this.event.show_downloads) {
        tabs.push({
          key: "downloads",
          label: "Downloads",
          icon: "download",
          ga_category: "Event",
          ga_label: this.gaLabel,
          ga_value: this.event.id,
        });
      }
      if (!!this.event.show_shipping) {
        tabs.push({
          key: "shipping",
          label: "Shipping",
          icon: "mail",
          ga_category: "Event",
          ga_label: this.gaLabel,
          ga_value: this.event.id,
        });
      }
      return tabs;
    },
    gaLabel() {
      return (
        this.$moment(this.event.start_date).format("MM/DD/YYYY") +
        " - " +
        this.event.name
      );
    },
  },
  watch: {
    tab(val) {
      this.currentTab = val;
    },
  },
  methods: {
    showTab(tab) {
      this.currentTab = tab;
    },
  },
  created() {
    this.currentTab = this.tab || "details";
  },
};
</script>
